/**
 * フォームの項目の種類（02 D-059 FormDefinition の fields[].field_type）。公開フォーム（public-form.schema・widget）が
 * フォーム定義の Zod（form.schema）を読み込まずに使えるように分けた（⑥：widget.js を軽くするため：03 FE-D-113）。
 */
export const FORM_FIELD_TYPE_VALUES = [
  'text',
  'textarea',
  'email',
  'tel',
  'url',
  'number',
  'select',
  'radio',
  'checkbox',
  'date',
  'file',
] as const;
export type FormFieldType = (typeof FORM_FIELD_TYPE_VALUES)[number];

export const FORM_FIELD_TYPE_LABELS: Readonly<Record<FormFieldType, string>> = {
  text: '1 行のテキスト',
  textarea: '複数行のテキスト',
  email: 'メールアドレス',
  tel: '電話番号',
  url: 'URL',
  number: '数値',
  select: 'プルダウン',
  radio: 'ラジオボタン',
  checkbox: 'チェックボックス（複数選択）',
  date: '日付',
  file: 'ファイル添付',
};

/** 選択肢を持つ種類（options が 1〜50 個必須） */
export const CHOICE_FIELD_TYPES: ReadonlySet<FormFieldType> = new Set(['select', 'radio', 'checkbox']);
